import { useEffect, useState } from "react";
import { Flag } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { PendingNoteDialog } from "./TaskGrid";

export default function AdminPendingTasks() {
  const [reasons, setReasons] = useState([]);
  const [pending, setPending] = useState([]);
  const [flagReason, setFlagReason] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/tasks/pending").then((r) => setPending(r.data || [])).catch(() => {});
    api.get("/settings/public/break-reasons")
      .then((r) => setReasons((r.data.reasons || []).map((x) => (typeof x === "string" ? x : x?.name)).filter(Boolean).sort((a, b) => a.localeCompare(b, "es"))))
      .catch(() => {});
  };
  useEffect(load, []);

  const pendingMap = Object.fromEntries(pending.map((p) => [p.reason, p]));

  const toggle = async (name) => {
    if (!pendingMap[name]) { setFlagReason(name); return; }
    try {
      await api.delete(`/tasks/pending/${encodeURIComponent(name)}`);
      toast.success("Tarea ya no está pendiente");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const confirm = async (note) => {
    setBusy(true);
    try {
      await api.post("/tasks/pending", { reason: flagReason, note, by_admin: true });
      toast.success("Tarea marcada como pendiente");
      setFlagReason(null);
      load();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card-flat p-6 rounded-2xl" data-testid="admin-pending-tasks">
      <div className="label-cap mb-1">tareas pendientes</div>
      <p className="text-sm text-[var(--text-secondary)] mb-4">
        Marca tareas que hay que hacer. Aparecen en rojo y primero en la pantalla de fichaje, y se quitan solas cuando alguien las inicia.
      </p>
      <div className="flex flex-wrap gap-2">
        {reasons.map((name) => {
          const p = pendingMap[name];
          return (
            <button
              key={name}
              type="button"
              onClick={() => toggle(name)}
              data-testid={`admin-pending-toggle-${name}`}
              title={p?.note || ""}
              className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl border text-sm font-display font-semibold transition-colors ${p ? "bg-red-600 text-white border-red-600" : "bg-white border-[var(--border)] hover:border-red-400 hover:text-red-600"}`}
            >
              <Flag size={14} weight={p ? "fill" : "bold"} />
              {name}
              {p?.note && <span className="font-normal italic opacity-90 max-w-[160px] truncate">· {p.note}</span>}
            </button>
          );
        })}
      </div>
      {flagReason && <PendingNoteDialog reason={flagReason} busy={busy} onCancel={() => setFlagReason(null)} onConfirm={confirm} />}
    </div>
  );
}
